import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';
import {
    AutoSizer,
    CellMeasurer,
    CellMeasurerCache,
    List,
    ListRowProps
} from 'react-virtualized';

import { Bem } from '../../service/Bem/Bem';
import {
    CheckBoxChangeData,
    Dictionary,
    DisplayListItem as ListItem,
    MapType,
    SelectedScreens
} from '../../typings/displayMap';
import { DisplayListItem } from '../DisplayListItem/DisplayListItem';

import './DisplayList.css';
import * as keyset from './DisplayList.i18n';

const i18n = i18nFactory(keyset);

export interface DisplayListState {
    scrollTop?: number;
}

export interface DisplayListProps {
    searchText: string;
    mapType: MapType;
    platforms: ListItem[];
    scrollToRow?: number | undefined;
    selectedScreens: SelectedScreens;
    highlightedGroups: string[];
    dictionary: Dictionary;
    selectedRegionsCount: number;
    onAnimationComplete: () => void;
    onScreensSelect: (data: CheckBoxChangeData) => void;
    onAddressGroupClick: (group: ListItem) => void;
}

export class DisplayList extends React.Component<
    DisplayListProps,
    DisplayListState
> {
    private block = 'display-list';
    private List: List | null;
    private cache: CellMeasurerCache;

    constructor(props: DisplayListProps) {
        super(props);

        this.cache = new CellMeasurerCache({
            fixedWidth: true,
            defaultHeight: 95
        });

        this.state = {
            scrollTop: undefined
        };
    }

    componentDidUpdate(prevProps: DisplayListProps) {
        if (this.props.scrollToRow !== prevProps.scrollToRow) {
            if (this.List) {
                this.List.scrollToRow(this.props.scrollToRow);
            }
        }
    }

    componentWillReceiveProps() {
        if (this.List) {
            this.List.forceUpdateGrid();
        }
    }

    render() {
        const { platforms } = this.props;
        this.cache.clearAll();

        return (
            <div className={Bem.cls(this.block)}>
                <div className={Bem.cls(this.block, 'list')}>
                    <AutoSizer>
                        {({ width, height }) => {
                            return (
                                <List
                                    ref={ref => (this.List = ref)}
                                    width={width}
                                    height={height}
                                    className={Bem.cls(this.block, 'grid')}
                                    deferredMeasurementCache={this.cache}
                                    // @ts-ignore - неверный тайпинг в библиотеке
                                    rowHeight={this.cache.rowHeight}
                                    rowRenderer={this.renderRow}
                                    noRowsRenderer={this.onNoRowsRender}
                                    rowCount={platforms.length}
                                    overscanRowCount={3}
                                    scrollToRow={undefined}
                                    scrollToAlignment={'start'}
                                    scrollTop={this.state.scrollTop}
                                />
                            );
                        }}
                    </AutoSizer>
                </div>
            </div>
        );
    }

    private onNoRowsRender = () => {
        const { selectedRegionsCount } = this.props;

        return (
            <div className={Bem.cls(this.block, 'empty-msg')}>
                {selectedRegionsCount
                    ? i18n('empty-selected-screens')
                    : i18n('need-to-select-city')}
            </div>
        );
    };

    private renderRow = ({ index, key, style, parent }: ListRowProps) => {
        const {
            mapType,
            platforms,
            onScreensSelect,
            selectedScreens,
            highlightedGroups,
            dictionary,
            onAddressGroupClick,
            searchText
        } = this.props;
        const platform = platforms[index];
        const isChecked =
            selectedScreens[platform.regionId] &&
            selectedScreens[platform.regionId].includes(platform.id);

        return (
            <CellMeasurer
                key={platform.id}
                cache={this.cache}
                // @ts-ignore - неверный тайпинг в библиотеке
                parent={parent}
                columnIndex={0}
                rowIndex={index}
            >
                <div style={style}>
                    <DisplayListItem
                        searchText={searchText}
                        mapType={mapType}
                        platform={platform}
                        onCheck={onScreensSelect}
                        checked={isChecked}
                        highlighted={highlightedGroups.includes(platform.id)}
                        dictionary={dictionary}
                        onAddressClick={onAddressGroupClick}
                    />
                </div>
            </CellMeasurer>
        );
    };
}
